<template>
  <div class="prototype-page" :style="pageStyle">
    <div class="app-shell">
      <header class="page-header">
        <div class="header-inner">
          <div class="logo">
            <div class="logo-badge">3P</div>
            <span class="site-title">3P影视</span>
          </div>
          <div class="domain-display">
            <div class="domain-slider">
              <span v-for="(domain, idx) in domains" :key="idx" class="domain-item">{{ domain }}</span>
            </div>
          </div>
          <div class="header-action" @click="handleHeaderAction">{{ currentUser.username || '登录' }}</div>
        </div>
        <!-- <div class="search-bar-container">
          <div class="search-bar">搜索同城 / 附近的人</div>
        </div> -->
      </header>

      <div class="notice-bar">{{ notice }}</div>

      <!-- 同城广告位置 -->
      <section class="section">
        <div class="section-title">
          <h2>同城推荐</h2>
        </div>
      </section>

      <!-- 炫酷胶囊按钮列表区 -->
      <div class="nav-stack">
        <!-- 动态生成的胶囊按钮 -->
        <a v-for="(ad, index) in bgAds" :key="ad.id" :href="ad.url" class="nav-btn" :class="`color-${(index % 6) + 1}`">
          <div class="nav-btn-content">
            <span class="nav-btn-tag">【{{ ad.title.split(' ')[0] || '同城推荐' }}】</span>
            <span class="nav-btn-title">{{ ad.title }}</span>
          </div>
          <div class="nav-btn-arrow"><svg viewBox="0 0 24 24"><path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6z"/></svg></div>
        </a>
      </div>

    </div>
  
    <nav class="bottom-nav">
      <router-link
        v-for="item in navItems"
        :key="item.key"
        class="nav-item"
        :class="{ active: item.key === 'city' }"
        :to="item.to"
      >
        <div v-html="item.svg" class="nav-icon"></div>
        <span>{{ item.label }}</span>
      </router-link>
    </nav>

    <AuthModal
      v-if="authVisible"
      :mode="authMode"
      @close="closeAuth"
      @change-mode="authMode = $event"
      @success="handleAuthSuccess"
    />
  </div>
</template>

<script>
import AuthModal from "@/views/AuthModal.vue";
import { navItems } from "@/prototype/navigation";
import { decryptApiPayload, getCachedNavUrlList } from "@/prototype/render-helpers";
import { siteData } from "@/prototype/site-data";
import { iv6Api, getAdsListApi } from "@/api/api";

export default {
  name: "CityPage",
  components: {
    AuthModal,
  },
  data() {
    return {
      apiAds: [],
      initNotice: "",
      cityBackImg: "",
      currentUser: { id: "", username: "", token: "" },
      authVisible: false,
      authMode: "login",
      navItems,
      siteData,
      domains: getCachedNavUrlList(),
    };
  },
  computed: {
    pageStyle() {
      if (this.cityBackImg) {
        return {
          backgroundImage: `url(${this.cityBackImg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundAttachment: 'fixed',
          minHeight: '100vh'
        };
      }
      return {};
    },
    notice() {
      return this.initNotice || this.siteData.notice;
    },
    textAds() {
      return [];
    },
    bgAds() {
      const source = this.apiAds.length ? this.apiAds : this.siteData.ads;
      return source.filter((item) => item.position == 3);
    },
    iconAds() {
      return [];
    },
    moduleAds() {
      return [];
    },
  },
  mounted() {
    this.refreshAuthState();
    this.fetchInitData();
    this.fetchAds();
    window.addEventListener("auth-changed", this.refreshAuthState);
  },
  beforeDestroy() {
    window.removeEventListener("auth-changed", this.refreshAuthState);
  },
  methods: {
    async fetchAds() {
      try {
        const res = await getAdsListApi({ limit: 100 });
        const list = decryptApiPayload(res, this.$decryptData);
        if (Array.isArray(list)) {
          this.apiAds = list;
        }
      } catch (error) {
        console.error("Failed to fetch ads", error);
      }
    },
    async fetchInitData() {
      try {
        const ldk = window.localStorage.getItem("ldk") || "";
        const res = await iv6Api({
          ldk: ldk,
          payed: 0,
          shebei_type: this.getDeviceType(),
        });
        const temp = this.decryptPayload(res);
        if (!temp) return;
        this.initNotice = temp.tip_content || this.siteData.notice;
        if (temp.cityBackImg) {
          this.cityBackImg = temp.cityBackImg;
        }
      } catch (error) {
        console.error("Failed to fetch init data", error);
      }
    },
    getDeviceType() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      if (/android/i.test(userAgent)) return 1;
      if (/iPad|iPhone|iPod/.test(userAgent)) return 2;
      return -1;
    },
    decryptPayload(payload) {
      try {
        const decryptedText = this.$decryptData(payload);
        return decryptedText ? JSON.parse(decryptedText) : null;
      } catch (error) {
        return null;
      }
    },
    adStyle(index) {
      const palette = this.siteData.adPalette[index % this.siteData.adPalette.length];
      return {
        background: palette.bg,
        color: palette.text,
      };
    },
    adTagColor(index) {
      return this.siteData.adPalette[index % this.siteData.adPalette.length].tag;
    },
    refreshAuthState() {
      try {
        const userInfo = window.localStorage.getItem("userInfo");
        this.currentUser = userInfo ? JSON.parse(userInfo) : { id: "", username: "", token: "" };
      } catch (error) {
        this.currentUser = { id: "", username: "", token: "" };
      }
    },
    handleHeaderAction() {
      if (this.currentUser && this.currentUser.id) {
        this.$router.push("/mine");
        return;
      }
      this.openAuth("login");
    },
    handleAuthSuccess(user) {
      this.currentUser = user || this.currentUser;
      this.refreshAuthState();
      this.closeAuth();
    },
    openAuth(mode) {
      this.authMode = mode;
      this.authVisible = true;
    },
    closeAuth() {
      this.authVisible = false;
    },
  },
};
</script>

<style scoped>
/* 使app-shell背景透明，以透出prototype-page的背景图 */
.app-shell {
  background: transparent !important;
}

/* 炫酷胶囊按钮列表区 */
.nav-stack {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 0 14px 20px;
}

.nav-btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-radius: 12px;
  text-decoration: none;
  color: #ffffff;
  transition: transform 0.2s ease, filter 0.2s ease;
  position: relative;
  overflow: hidden;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.nav-btn:active {
  transform: scale(0.96);
  filter: brightness(1.1);
}

.nav-btn-content {
  display: flex;
  align-items: center;
  gap: 10px;
  z-index: 2;
}

.nav-btn-tag {
  background: rgba(255, 255, 255, 0.25);
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  text-shadow: none;
  letter-spacing: 0;
}

.nav-btn-title {
  font-size: 15px;
  color: #ffffff;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.nav-btn-arrow {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.25);
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(4px);
  z-index: 2;
}

.nav-btn-arrow svg {
  width: 14px;
  height: 14px;
  fill: #ffffff;
}

/* 按钮配色池 (半透明毛玻璃配色) */
.color-1 { background: linear-gradient(135deg, rgba(108, 141, 255, 0.9), rgba(80, 103, 255, 0.9)); box-shadow: 0 6px 16px rgba(80, 103, 255, 0.25); }
.color-2 { background: linear-gradient(135deg, rgba(176, 107, 243, 0.9), rgba(144, 71, 255, 0.9)); box-shadow: 0 6px 16px rgba(144, 71, 255, 0.25); }
.color-3 { background: linear-gradient(135deg, rgba(255, 92, 119, 0.9), rgba(247, 59, 91, 0.9)); box-shadow: 0 6px 16px rgba(247, 59, 91, 0.25); }
.color-4 { background: linear-gradient(135deg, rgba(56, 211, 129, 0.9), rgba(33, 184, 101, 0.9)); box-shadow: 0 6px 16px rgba(33, 184, 101, 0.25); }
.color-5 { background: linear-gradient(135deg, rgba(250, 205, 21, 0.9), rgba(234, 179, 8, 0.9)); box-shadow: 0 6px 16px rgba(234, 179, 8, 0.25); }
.color-6 { background: linear-gradient(135deg, rgba(108, 141, 255, 0.9), rgba(80, 103, 255, 0.9)); box-shadow: 0 6px 16px rgba(80, 103, 255, 0.25); }
</style>
